import globalAxios from 'axios';
import { B as BaseAPI, a as assertParamExists, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * PromotionPoliciesApi - axios parameter creator
 * @export
 */
const PromotionPoliciesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Creates a new promotion policy (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyToken} PromotionPolicyToken The data of the new promotion policy to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create: async (PromotionPolicyToken, options = {}) => {
            // verify required parameter 'PromotionPolicyToken' is not null or undefined
            assertParamExists('create', 'PromotionPolicyToken', PromotionPolicyToken);
            const localVarPath = `/v1/PromotionPolicies/Create`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PromotionPolicyToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a promotion policy by its id (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/PromotionPolicies/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers: async (options = {}) => {
            const localVarPath = `/v1/PromotionPolicies/GetOffers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System,FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionPolicyOrderEvents: async (id, options = {}) => {
            const localVarPath = `/v1/PromotionPolicies/GetPromotionPolicyOrderEvents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Bulk-resolves a list of product codes/barcodes (pasted text and/or an uploaded .xlsx/.csv/.txt file) to product ids so the admin can apply a promotion policy to many products at once. This resolves and reports only — the caller merges the matched ids into the policy\'s product selection and persists via the normal Update. Matching is case-insensitive against BizWeb.NC.Data.Domain.Catalog.Product.Code OR BizWeb.NC.Data.Domain.Catalog.Product.Barcode. (Auth roles: PromotionPolicies)
         * @param {string} [codes] Optional pasted list of codes/barcodes separated by newlines, commas, semicolons or tabs.
         * @param {File} [file] Optional .xlsx/.csv/.txt file; codes are read from the first column of each row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProducts: async (codes, file, options = {}) => {
            const localVarPath = `/v1/PromotionPolicies/ImportProducts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (codes !== undefined) {
                localVarFormParams.append('codes', codes);
            }
            if (file !== undefined) {
                localVarFormParams.append('file', file);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = localVarFormParams;
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Queries the promotion policies (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyQueryRequest} PromotionPolicyQueryRequest Options for querying promotion policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query: async (PromotionPolicyQueryRequest, options = {}) => {
            // verify required parameter 'PromotionPolicyQueryRequest' is not null or undefined
            assertParamExists('query', 'PromotionPolicyQueryRequest', PromotionPolicyQueryRequest);
            const localVarPath = `/v1/PromotionPolicies/Query`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PromotionPolicyQueryRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Deletes a promotion policy by its id (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/PromotionPolicies/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Updates a promotion policy (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyToken} PromotionPolicyToken The data of the promotion policy to update
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (PromotionPolicyToken, id, options = {}) => {
            // verify required parameter 'PromotionPolicyToken' is not null or undefined
            assertParamExists('update', 'PromotionPolicyToken', PromotionPolicyToken);
            const localVarPath = `/v1/PromotionPolicies/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(PromotionPolicyToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PromotionPoliciesApi - functional programming interface
 * @export
 */
const PromotionPoliciesApiFp = function (configuration) {
    const localVarAxiosParamCreator = PromotionPoliciesApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary Creates a new promotion policy (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyToken} PromotionPolicyToken The data of the new promotion policy to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async create(PromotionPolicyToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.create(PromotionPolicyToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.create']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Gets a promotion policy by its id (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOffers(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOffers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.getOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System,FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPromotionPolicyOrderEvents(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPromotionPolicyOrderEvents(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.getPromotionPolicyOrderEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Bulk-resolves a list of product codes/barcodes (pasted text and/or an uploaded .xlsx/.csv/.txt file) to product ids so the admin can apply a promotion policy to many products at once. This resolves and reports only — the caller merges the matched ids into the policy\'s product selection and persists via the normal Update. Matching is case-insensitive against BizWeb.NC.Data.Domain.Catalog.Product.Code OR BizWeb.NC.Data.Domain.Catalog.Product.Barcode. (Auth roles: PromotionPolicies)
         * @param {string} [codes] Optional pasted list of codes/barcodes separated by newlines, commas, semicolons or tabs.
         * @param {File} [file] Optional .xlsx/.csv/.txt file; codes are read from the first column of each row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async importProducts(codes, file, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.importProducts(codes, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.importProducts']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Queries the promotion policies (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyQueryRequest} PromotionPolicyQueryRequest Options for querying promotion policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async query(PromotionPolicyQueryRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.query(PromotionPolicyQueryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.query']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Deletes a promotion policy by its id (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary Updates a promotion policy (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyToken} PromotionPolicyToken The data of the promotion policy to update
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(PromotionPolicyToken, id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(PromotionPolicyToken, id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PromotionPoliciesApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * PromotionPoliciesApi - factory interface
 * @export
 */
const PromotionPoliciesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = PromotionPoliciesApiFp(configuration);
    return {
        /**
         *
         * @summary Creates a new promotion policy (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyToken} PromotionPolicyToken The data of the new promotion policy to create
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        create(PromotionPolicyToken, options) {
            return localVarFp.create(PromotionPolicyToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Gets a promotion policy by its id (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOffers(options) {
            return localVarFp.getOffers(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System,FrontEndUsers)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPromotionPolicyOrderEvents(id, options) {
            return localVarFp.getPromotionPolicyOrderEvents(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Bulk-resolves a list of product codes/barcodes (pasted text and/or an uploaded .xlsx/.csv/.txt file) to product ids so the admin can apply a promotion policy to many products at once. This resolves and reports only — the caller merges the matched ids into the policy\'s product selection and persists via the normal Update. Matching is case-insensitive against BizWeb.NC.Data.Domain.Catalog.Product.Code OR BizWeb.NC.Data.Domain.Catalog.Product.Barcode. (Auth roles: PromotionPolicies)
         * @param {string} [codes] Optional pasted list of codes/barcodes separated by newlines, commas, semicolons or tabs.
         * @param {File} [file] Optional .xlsx/.csv/.txt file; codes are read from the first column of each row.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importProducts(codes, file, options) {
            return localVarFp.importProducts(codes, file, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Queries the promotion policies (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyQueryRequest} PromotionPolicyQueryRequest Options for querying promotion policies
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        query(PromotionPolicyQueryRequest, options) {
            return localVarFp.query(PromotionPolicyQueryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Deletes a promotion policy by its id (Auth roles: PromotionPolicies)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Updates a promotion policy (Auth roles: PromotionPolicies)
         * @param {PromotionPolicyToken} PromotionPolicyToken The data of the promotion policy to update
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(PromotionPolicyToken, id, options) {
            return localVarFp.update(PromotionPolicyToken, id, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * PromotionPoliciesApi - object-oriented interface
 * @export
 * @class PromotionPoliciesApi
 * @extends {BaseAPI}
 */
class PromotionPoliciesApi extends BaseAPI {
    /**
     *
     * @summary Creates a new promotion policy (Auth roles: PromotionPolicies)
     * @param {PromotionPolicyToken} PromotionPolicyToken The data of the new promotion policy to create
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    create(PromotionPolicyToken, options) {
        return PromotionPoliciesApiFp(this.configuration).create(PromotionPolicyToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Gets a promotion policy by its id (Auth roles: PromotionPolicies)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    getById(id, options) {
        return PromotionPoliciesApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    getOffers(options) {
        return PromotionPoliciesApiFp(this.configuration).getOffers(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System,FrontEndUsers)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    getPromotionPolicyOrderEvents(id, options) {
        return PromotionPoliciesApiFp(this.configuration).getPromotionPolicyOrderEvents(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Bulk-resolves a list of product codes/barcodes (pasted text and/or an uploaded .xlsx/.csv/.txt file) to product ids so the admin can apply a promotion policy to many products at once. This resolves and reports only — the caller merges the matched ids into the policy\'s product selection and persists via the normal Update. Matching is case-insensitive against BizWeb.NC.Data.Domain.Catalog.Product.Code OR BizWeb.NC.Data.Domain.Catalog.Product.Barcode. (Auth roles: PromotionPolicies)
     * @param {string} [codes] Optional pasted list of codes/barcodes separated by newlines, commas, semicolons or tabs.
     * @param {File} [file] Optional .xlsx/.csv/.txt file; codes are read from the first column of each row.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    importProducts(codes, file, options) {
        return PromotionPoliciesApiFp(this.configuration).importProducts(codes, file, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Queries the promotion policies (Auth roles: PromotionPolicies)
     * @param {PromotionPolicyQueryRequest} PromotionPolicyQueryRequest Options for querying promotion policies
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    query(PromotionPolicyQueryRequest, options) {
        return PromotionPoliciesApiFp(this.configuration).query(PromotionPolicyQueryRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Deletes a promotion policy by its id (Auth roles: PromotionPolicies)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    remove(id, options) {
        return PromotionPoliciesApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Updates a promotion policy (Auth roles: PromotionPolicies)
     * @param {PromotionPolicyToken} PromotionPolicyToken The data of the promotion policy to update
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PromotionPoliciesApi
     */
    update(PromotionPolicyToken, id, options) {
        return PromotionPoliciesApiFp(this.configuration).update(PromotionPolicyToken, id, options).then((request) => request(this.axios, this.basePath));
    }
}

export { PromotionPoliciesApi, PromotionPoliciesApiAxiosParamCreator, PromotionPoliciesApiFactory, PromotionPoliciesApiFp };
//# sourceMappingURL=promotion-policies-api.js.map
